<template>
  <ElDialog
      v-model="isShow"
      :title="targetTitle"
      :footer="null"
      centered
      :width="520"
      destroyOnClose
      @cancel="close"
      :close-on-click-modal="false"
      :class="[isHeadLine ? 'headline' : 'noheadline']"
  >
    <div style="display: flex;justify-content: flex-start;align-items: center">
      <!--            {{tableData}}-->
      <template v-if="settingType===1">
        <div class="box_inner">
          <div class="title"> {{
              isSelectAll ? $t('customer.more.list.setting1.all', {customer: $t('common.all')}) : $t('customer.more.list.setting1', {customer: multipleSelection.length})
            }}
          </div>
          <div style="display: flex;justify-content: flex-start;align-items:center;margin-top: 5px;">
            <el-select style="width: 200px;margin-top: 16px" size="small" v-model="updateCustomerTypeId"
                       @change="handleClickChange"
                       :placeholder="$t('common.please.select')" clearable>
              <el-option
                  v-for="item in tableData"
                  :key="item.customerLevel"
                  :label="item.customerLevel"
                  :value="item.id"
              ></el-option>
            </el-select>
            <div
                class="select_box">
              {{ selectTargetType }}
            </div>
          </div>
        </div>
      </template>
      <template v-if="settingType===2">
        <div class="box_inner">
          <div class="title" style="margin-bottom: 16px;">{{
              isSelectAll ? $t('customer.more.list.setting2.all', {customer: $t('common.all')}) : $t('customer.more.list.setting2', {customer: multipleSelection.length})
            }}
          </div>
          <SelectEditTag style="margin-top: 5px;" v-model:selectedMember="updateCustomerOriginList" ref="selectTag"
                         :typeSelect="1" :isOnlyTagFlag="true"></SelectEditTag>
        </div>
      </template>
      <template v-if="settingType===3">
        <div class="box_inner">
          <div class="title" style="margin-bottom: 16px;">{{
              isSelectAll ? $t('customer.more.list.setting3.all', {customer: $t('common.all')}) : $t('customer.more.list.setting3', {customer: multipleSelection.length})
            }}
          </div>
          <SelectEditTag style="margin-top: 5px;" v-model:selectedMember="updateProductList" ref="selectTag"
                         :typeSelect="2" :isOnlyTagFlag="true"></SelectEditTag>
        </div>
      </template>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <ElButton size="small" @click="close">
          {{
            $t("common.cancel")
          }}
        </ElButton>
        <ElButton size="small" type="primary" @click="createDir" :loading="loading">
          {{
            $t("common.confirm")
          }}
        </ElButton>
      </div>
    </template>
  </ElDialog>
</template>

<script setup>
import {ElButton, ElDialog, ElInput, ElMessage} from "element-plus";
import {ref, defineProps, watch, defineEmits, computed, onMounted, nextTick} from 'vue'
import {useStore} from "vuex";
import {addEmailGroupFile, updateEmailGroupFile} from "@/api/sidebar";
import {i18n} from "@/lang";
import SelectEditTag from "@/components/SelectEditTag.vue";
import SelectUser from "@/views/Home/components/SelectUser.vue";

const store = useStore();
const emit = defineEmits(['close', 'getList', 'getInit'])
const isShow = ref(false);
const fileDirName = ref("")
const loading = ref(false)
const teamId = computed(() => store.state.email.teamID);

const {
  value,
  isHeadLine,
  isEdit,
  currentItem,
  settingType,
  command,
  multipleSelection,
  isSelectAll,
  searchValue
} = defineProps({
  value: {type: Boolean, default: false},
  isHeadLine: {type: Boolean, default: false},
  isEdit: {type: Boolean, default: false},
  currentItem: {type: Object, default: {}},
  isTop: {type: Number, default: 0},
  settingType: {type: Number, default: 0},
  command: {type: String, default: ''},
  multipleSelection: {type: Object, default: []},
  isSelectAll: {type: Boolean, default: false},
  searchValue: {type: String, default: ''},
})

// 计算对话框的标题
const targetTitle = computed(() => {
  if (settingType === 1) {
    return i18n.global.t('customer.list.setting1')
  } else if (settingType === 2) {
    return i18n.global.t('customer.list.setting2')
  } else if (settingType === 3) {
    return i18n.global.t('customer.list.setting3')
  }
})


// 客户等级
const updateCustomerTypeId = ref('')
const tableData = computed(() => store.state.cusList.tableData);

const selectTargetType = ref('')
const handleClickChange = (id) => {
  const targetCustomerType = tableData.value.find(item => item.id === id)?.customerType
  // console.log(targetCustomerType, id, 'dddd', tableData.value)
  updateCustomerTypeId.value = id;
  selectTargetType.value = targetCustomerType
}

// 客户来源
const updateCustomerOriginList = ref([])
const customerSelectData = computed(() => store.state.cusList.customerSelectData);
const empty = ref(i18n.global.t('select.empty'))


// 意向产品
const updateProductList = ref([])

watch(() => value, (val) => {
  isShow.value = val;
}, {immediate: true})
const close = () => {
  emit("close");
}

onMounted(async () => {
  await store.dispatch("cusList/getMailCustomerLevel", {teamId: teamId.value, isUpdate: true});
})

const isLoading = ref(false)
const createDir = async () => {
  console.log('click')
  try {
    isLoading.value = true
    let payload = {
      "customerIdList": multipleSelection.map(item => item.id),
      "updateCustomerOriginList": updateCustomerOriginList.value,
      "updateCustomerTypeId": updateCustomerTypeId.value,
      "updateProductList": updateProductList.value,
      "teamId": teamId.value,
      selectAll: isSelectAll,
      managerId: searchValue?.managerId,
      ...searchValue,
    }
    if (settingType === 1) {
      delete payload.updateCustomerOriginList
      delete payload.updateProductList
      if (updateCustomerTypeId.value === '') {
        payload.updateType = 3
        delete payload.updateCustomerTypeId
      }
    } else if (settingType === 2) {
      delete payload.updateCustomerTypeId
      delete payload.updateProductList
      if (updateCustomerOriginList.value?.length === 0) {
        payload.updateType = 1
        delete payload.updateCustomerOriginList
      }
    } else if (settingType === 3) {
      delete payload.updateCustomerOriginList
      delete payload.updateCustomerTypeId
      if (updateProductList.value?.length === 0) {
        payload.updateType = 2
        delete payload.updateProductList
      }
    }
    if (isSelectAll) {
      delete payload.customerIdList
    }
    await store.dispatch("customer/batchUpdateCustomerInfoApi", payload)
    isLoading.value = false
    close();
    if (isSelectAll) {
      ElMessage.success(i18n.global.t('common.text.compute.result'))
      await emit('getInit')
    } else {
      console.log('dssdsdsdsd')
      ElMessage.success(i18n.global.t('0'))
      // setTimeout(async () => {
      await emit("getList")
      // }, 600)
    }
  } catch (e) {
    isLoading.value = false
  }
}

const isChange = ref(false)
watch(() => fileDirName.value, (newValue) => {
  isChange.value = true
})

</script>
<style scoped lang="less">
.fx-j-c {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.title_cdir {
  color: rgba(0, 0, 0, .85);
  font-weight: 700;
  font-size: 14px;
}

.fx-j-r {
  display: flex;
  justify-content: right;
  margin-top: 40px;
}


.box_inner {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
}


.el-select-dropdown__item {
  min-width: auto !important;
  width: auto;
  max-width: 300px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown-menu-wrapper {
  min-width: auto !important;
  width: auto;
  max-width: 300px !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

:deep(.el-dropdown-menu__item) {
  min-width: auto !important;
  width: auto;
  max-width: 300px !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inherit !important;
}

.select_box {
  width: 200px;
  height: 24px;
  margin-top: 16px;
  margin-left: 16px;
  border: 1px solid #d7dae2;
  border-radius: 4px;
  padding-left: 6px;
  font-size: 13px;
  line-height: 24px;
}

:deep(.el-select-dropdown__item) {
  width: 100% !important;
  min-width: 230px !important;
}
</style>
